import { gql } from "@apollo/client"
import { InjectedOptions, useMutation } from "@oysterhr/core"
import {
  CreateManualKycVerificationInput,
  CreateManualKycVerificationPayload,
} from "@oysterhr/schema"

const CREATE_MANUAL_KYC_VERIFICATION = gql`
  mutation CreateManualKycVerification($userId: ID!, $reason: String!, $status: String!) {
    createManualKycVerification(input: { userId: $userId, reason: $reason, status: $status }) {
      user {
        id
        latestKycVerification {
          id
          status
          updatedAt
          verifier {
            name
            email
          }
          reason
        }
      }
      errors
    }
  }
`

export const useCreateManualKycVerification = (
  options?: InjectedOptions<CreateManualKycVerificationPayload, CreateManualKycVerificationInput>,
) =>
  useMutation<CreateManualKycVerificationPayload, CreateManualKycVerificationInput>(
    CREATE_MANUAL_KYC_VERIFICATION,
    options,
  )
